// @flow
import styled from 'styled-components';

export const TabItem = styled.li`
	font-size: 14px;
	color: #003A31;
	font-weight: 600;
	font-family: RL2Font;
	border-top: 3px solid transparent;
	border-bottom: 3px solid transparent;
	width: 120px;
	height: 40px;
	cursor: pointer;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	&.active-tab {
		cursor: default;
		border-bottom-color: #00FF9A;;
	}
`;

export default TabItem;


// WEBPACK FOOTER //
// ./src/components/TabItem/index.js